import r from "./_isArrayLike.js";
import i from "./findIndex.js";
import f from "./findKey.js";
function o(o, n, t) {
  var d = (r(o) ? i : f)(o, n, t);
  if (void 0 !== d && -1 !== d) return o[d];
}
export { o as default };